/* eslint-disable require-jsdoc */
/* eslint-disable no-undef */

import React, {useEffect} from 'react';
import hasProp from 'hasprop';
import {Loader} from '@googlemaps/js-api-loader';
import {stylers} from './stylers';
import markerTmpl from './marker.tmpl';
import {isValid} from '../../../utils/validate';


const mapFunc = (props) => {
  const mapId=isValid(props.mapId) ? props.mapId : 1;

  const mapObject =
    document.getElementById(`hearby-map-popup-${mapId}`);

  // console.log('mapFunc mapId', mapId, mapObject);
  return mapObject;
};

const PopUpMap = (props) => {
  // const tmpl=hasProp(props, ['venue']) ? markerTmpl(props.venue): 'Nothing';

  useEffect(() => {
    const loader = new Loader({
      apiKey: props.gMapApiKey,
      version: 'weekly',
    });

    if (hasProp(props.venue, ['lat']) && hasProp(props.venue, ['lon'])) {
      loader.load().then(() => {
        const map = new google.maps.Map(mapFunc(props), {
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          center: {lat: props.venue.lat, lng: props.venue.lon},
          zoom: 12,
          styles: stylers.styles,
          mapTypeControl: false,
          streetViewControl: false,
        });

        const tmpl = markerTmpl(props.venue);

        const infowindow = new google.maps.InfoWindow({
          content: String(tmpl),
        });

        const marker = new google.maps.Marker({
          position: {lat: props.venue.lat, lng: props.venue.lon},
          map: map,
          url: stylers.icons.hearbyEvents,
          title: props.venue.venueName,
          icon: {
            url: stylers.icons.hearbyEvents,
            scaledSize: new google.maps.Size(24, 34),
          },
          animation: google.maps.Animation.DROP,
        });

        infowindow.open(map, marker);

        // console.log('Map.js loader.load().map', map, marker);
      });
    }
    // console.log('Map.js props', props);
  });

  const mapIdForJSX=isValid(props.mapId) ? props.mapId : 1;

  return (
    <div>
      {hasProp(props, ['venue']) ?

      <div>
        <div className="hearby-details-row">
          <div className="hearby-col hearby-col-100">
            {/* {console.log('Map.js props in jsx', props)} */}
            {/* {console.log('markerTmpl'), tmpl} */}

            <div
              id={`hearby-map-popup-${mapIdForJSX}`}
              className={'hearby-map-popup'}
              style = {{height: '100%', width: '100%', minHeight: '50em'}}>
            </div>

          </div>
        </div>
      </div>: null}

    </div>
  );
};

export default PopUpMap;
